import React from 'react';
//import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Row, Col, Card } from 'react-bootstrap';
//import navigateBackground from './../images/kpit_navigate.png';
import kpitLogo from './../images/kpit_logo_new.png';
import simulib from './../images/simulib_icon.png';
import sceneGen from './../images/scene_gen_icon.png';
import automateKpi from './../images/automate_kpi_icon.png';
import testManager from './../images/test_manager_logo.png';
import sceneExtract from './../images/scene_extract_logo.png';


const NavigateNew = () => (
    <div data-test = 'navigateNewComponent'>
        <div id="background-img" >
            <div className="container">
                <div className="row" style={{ marginTop : "10px" , paddingTop: "1%" }}>
                    <div className="col-md-12" style={{  textAlign: "center" }}>
                        <img src={kpitLogo} alt=""/>
                    </div>
                </div>
                <div className="row" style={{ marginTop : "10px" , paddingTop: "1%" }}>
                    <div className="col-md-12" style={{ textAlign: "center" }}>
                        <h2>Welcome!</h2>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row" style={{ marginTop : "15px" , paddingTop: "2%" }}>
                        <div className="row">
                            <div className="col-md-2"></div>
                            <div className="col-md-4">
                                <Link to="/welcome_scenario_catalogue">
                                    <div className="card" id="info-box">
                                        <div className="card-body" style={{ textAlign: "center" }}>
                                            <img src={simulib} style={{ width: "68%" }} alt=""/>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-md-4">
                                <Link to="/scenario_editor">
                                    <div className="card" id="info-box">
                                        <div className="card-body" style={{ textAlign: "center" }}>
                                            <img src={sceneGen} alt="" style={{ width: "74%" }}/>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                        <div className="row" style={{ marginTop : "15px" , paddingTop: "2%" }}>
                            <div className="col-md-2"></div>
                            <div className="col-md-4">
                                <Link to="/welcomeautomatekpi">
                                    <div className="card" id="info-box">
                                        <div className="card-body align-items-center d-flex justify-content-center" style={{ textAlign: "center" }}>
                                            <img src={automateKpi} alt="" style={{ width: "90%", paddingTop: "2%" }}/>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-md-4">
                                <Link to="/event_analyzer_filtering" style={{ textDecoration: "none" }}>
                                    <div className="card" id="info-box">
                                        <div className="card-body align-items-center d-flex justify-content-center" style={{ textAlign: "center" }}>
                                            <img src={sceneExtract} alt="" style={{ width: "90%", paddingTop: "2%" }}/>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                        <div className="row" style={{ marginTop : "15px" , paddingTop: "2%" }}>
                            <div className="col-md-2"></div>
                            <div className="col-md-8">
                                {/* <Link to="/welcome"> */}
                                <Link to="/welcome">
                                    <div className="card">
                                        <Row>
                                            <Col md={12} xl={12}>
                                                <div className="card-body align-items-center d-flex justify-content-center" style={{ textAlign: "center" }}>
                                                    <img id="test-manager-img" src={testManager} alt="" style={{ width: "70%" }}/>
                                                </div>
                                            </Col>
                                        </Row>
                                        {/* <Row>
                                            <Col md={6} xl={6}>
                                                <Link to="/open_loop">
                                                    <Card className="card-body align-items-center d-flex justify-content-center" style={{ textAlign: "center" }}>
                                                        <Card.Body>
                                                            Open Loop
                                                        </Card.Body>
                                                    </Card>
                                                </Link>
                                            </Col>
                                            <Col md={6} xl={6}>
                                                <Link to="/close_loop">
                                                    <Card className="card-body align-items-center d-flex justify-content-center" style={{ textAlign: "center" }}>
                                                        <Card.Body>
                                                            Close Loop
                                                        </Card.Body>
                                                    </Card>
                                                </Link>
                                            </Col>
                                        </Row> */}
                                        {/* <Row className="justify-content-md-center">
                                            <Link to="/welcome_cm">
                                                <Card className="card-body align-items-center d-flex justify-content-center border-0" style={{ textAlign: "center" }}>
                                                    <Card.Body>
                                                        <h4>GET STARTED...</h4>
                                                    </Card.Body>
                                                </Card>
                                            </Link>
                                        </Row> */}
                                    </div>
                                </Link>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

export default NavigateNew;
